
import type { Story } from '../../../components/common/interfaces/types';
import {
    GetNewsStoriesActionType,
    GetNewsStoriesByDateActionType,
    GET_NEWS_STORIES_BY_DATE,
    GET_NEWS_STORIES } from '../../actions/stories/storiesAction';

export interface NewsStoriesState {
    stories: Story[];
    isFetchingNewsStories: boolean;
    lastError: unknown;
    storiesByDate: {
        stories: Story[];
        lastError?: unknown;
        pageNumber?: {
            page: number;
        }; 
        isFetchingStoriesByDate: boolean;
    };
}
const initialState: NewsStoriesState = {
    stories: [],
    isFetchingNewsStories: false,
    lastError: undefined,
    storiesByDate: {
        stories: [],
        lastError: undefined,
        isFetchingStoriesByDate: false 
    }
};

type NewsStoriesActionType = | GetNewsStoriesActionType | GetNewsStoriesByDateActionType;

export function newsStories(state = initialState, action: NewsStoriesActionType): NewsStoriesState
{
    switch (action.type)
    {
        case GET_NEWS_STORIES.pending:
        {
            return {
                ...state,
                isFetchingNewsStories: true,
                stories: [],
                lastError: undefined
            };
        }
        case GET_NEWS_STORIES.fulfilled:
        {
            return {
                ...state,
                isFetchingNewsStories: false,
                stories: action.payload as unknown as Story[],
                lastError: undefined
            };
        }
        case GET_NEWS_STORIES.rejected:
        {
            return {
                ...state,
                isFetchingNewsStories: false,
                stories: [],
                lastError: action.payload
            };
        }
        case GET_NEWS_STORIES_BY_DATE.pending:
        {
            return {
                ...state,
                storiesByDate: {
                    ...state.storiesByDate,
                    isFetchingStoriesByDate: true,
                    lastError: undefined
                }
            };
        }
        case GET_NEWS_STORIES_BY_DATE.fulfilled:
        {
            const stories = state?.storiesByDate?.stories?.length > 0 
                ? [ ...state?.storiesByDate?.stories, ...action.payload as unknown as Story[] ] 
                : action.payload as unknown as Story[];
            
            const pageNumber = state?.storiesByDate?.pageNumber && state?.storiesByDate?.pageNumber?.page > 0 ? { page: state.storiesByDate.pageNumber.page + 1 } : { page: 1 };

            return {
                ...state,
                storiesByDate: {
                    stories: stories,
                    lastError: undefined,
                    pageNumber: pageNumber,
                    isFetchingStoriesByDate: false
                }
            };
        }
        case GET_NEWS_STORIES_BY_DATE.rejected:
        {
            return {
                ...state,
                storiesByDate: {
                    ...state.storiesByDate,
                    lastError: undefined,
                    isFetchingStoriesByDate: false
                }
            };
        }

        default: {
            return {
                ...state
            };
        }
    }
}